<template>
  <div>
    <v-content>
      <v-layout row wrap align-start>
        <v-flex xs12 md12>
          <h1 class="content-title">Join</h1>
          <h2 class="content-sub-title">Spice Money</h2>

          <h3
            class="mb-4"
          >Become a part of a robust and fastest growing business model and earn rich dividends</h3>
        </v-flex>

        <v-flex xs12 sm6 class="px-4 mb-5 learship-container">
          <div style="clear:both"></div>
          <div class="leadership-name">Agent Benefits</div>
          <div class="blue-bar"></div>
          <ul class="leadership-designation">
            <li>Everyone can become a Spice Money Transfer Agent</li>
            <li>Earn commission on every transaction</li>
            <li>Transfer money to any bank account in India</li>
            <li>Convenient money transfer up to Rs 50,000 per sender/per month to any bank</li>
            <li>Secure process with multiple layers of authentication ensure that your money is safe during transit</li>
            <li>Increase your business and attract more customers</li>
            <li>Provide multiple services to your customers</li>
          </ul>
          <a
            class="red-button"
            href="https://lead.spicemoney.com/LeadGeneration/login?mode=web1"
            target="_blank"
          >Join Now</a>
        </v-flex>

        <v-flex xs12 sm6 class="px-4 mb-5 learship-container">
          <div style="clear:both"></div>
          <div class="leadership-name">Customer Benefits</div>
          <div class="blue-bar"></div>
          <ul class="leadership-designation">
            <li>Bank any time/anywhere hassle free</li>
            <li>Withdraw/deposit/transfer money instantly and easily</li>
            <li>Secure and trusted platform of fund transfer with SMS and receipt of transactions</li>
            <li>It's convenient - transfer up to Rs. 50,000 per month with min KYC (using our IndusInd and Yes Bank services) Rs. 50,000 per month with KYC (using Spice Money) to any bank account across India</li>
          </ul>
          <a
            class="red-button"
            href="https://lead.spicemoney.com/LeadGeneration/login?mode=web1"
            target="_blank"
          >Join Now</a>
        </v-flex>

        <v-flex></v-flex>
      </v-layout>
    </v-content>
  </div>
</template>

<style scoped>
h3 {
  font-weight: normal;
  font-size: 18px;
  font-style: italic;
  padding-bottom: 20px;
}
.content-title {
  color: #ed1c24;
  font-size: 24px;
  font-weight: normal;
  margin: 0;
  padding: 0;
  text-transform: uppercase;
}
.content-sub-title {
  font-size: 42px;
  line-height: 42px;
  text-transform: uppercase;
  color: #293896;
  margin-bottom: 30px;
}
.cursorpointer {
  cursor: pointer;
}
.content-image {
  cursor: crosshair;
}
.box-shadow {
  box-shadow: 0 0 30px #e3e3e3;
  background: #fff;
  padding: 40px 48px;
}
.leadership-img {
  position: relative;
  float: left;
}
.leadership-img img {
  position: relative;
  z-index: 3;
  max-width: 100%;
  float: left;
}
.blue-bar {
  width: 100px;
  height: 3px;
  background: #ed1c24;
  margin: 10px 0;
}
.bg-circle {
  position: absolute;
  border-radius: 50%;
  width: 100%;
  height: auto;
  padding-top: 100%;
  border: 2px dashed #a7a8aa;
  filter: alpha(opacity=60);
  filter: alpha(opacity=60);
  opacity: 0.6;
  z-index: 3;
  bottom: 10px;
  right: 10px;
}
.leadership-name {
  color: #2a3997;
  font-size: 30px;

  padding-top: 25px;
}
.leadership-designation {
  color: #242424;
  font-size: 20px;
  min-height: 281px;
  font-weight: 300;
}
.grey-circle {
  position: absolute;
  bottom: 0;
  border-radius: 50%;
  width: 100%;
  height: auto;
  padding-top: 100%;
  background-color: #ededed;
}
.learship-container {
  transition: all ease-in-out 0.5s;
}
.learship-container:hover {
  transform: scale(1.05, 1.05);
}
.red-button {
  margin-top: 30px;
  height: 80px;
  line-height: 80px;
  text-decoration: none;
  padding: 0 50px;
  border-radius: 3px;
  color: #fff;
  background: #ec1c25;
  display: inline-block;
  text-transform: uppercase;
  font-size: 30px;
  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.5);
}
ul {
  padding-top: 10px;
}
@media only screen and (max-width: 768px) {
  .content-title {
    font-size: 14px;
  }
  .content-sub-title {
    font-size: 16px;
    line-height: 16px;
  }

  h3 {
    font-size: 14px;
  }
  .leadership-name {
    font-size: 16px;
    padding-top: 25px;
  }
  .leadership-designation {
    font-size: 14px;
    min-height: inherit;
  }
  .red-button {
    margin-top: 20px;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    font-size: 16px;
  }
}
</style>

<script>
import JoinNow from "./JoinNow.ts";
export default JoinNow;
</script>